import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MapContainer, Marker, GeoJSON } from '../../../Maps';

const StyledMapContainer = styled(MapContainer)(({ theme }: any) => ({
  width: '100%',
  height: 260,
  borderRadius: theme.shape.borderRadius * 2,
}));

function PostLocation({ label, lat, lng, status, geojson }: any) {
  if (!label && !lat && !lng) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      {lat && lng && (
        <Box sx={{ mb: 3 }}>
          <StyledMapContainer center={[lat, lng]} geojson={geojson}>
            <Marker
              position={[lat, lng]}
              title={label || [lat, lng].join(',')}
              href={
                lat && lng
                  ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
                  : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(label)}`
              }
              status={status}
            />
            {geojson && <GeoJSON data={geojson} />}
          </StyledMapContainer>
        </Box>
      )}
    </Box>
  );
}

PostLocation.propTypes = {
  label: PropTypes.string,
  lat: PropTypes.string,
  lng: PropTypes.string,
  status: PropTypes.string,
};

export default PostLocation;
